import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";

import { Skeleton } from "@/components/ui/skeleton";
import { KeyValueGrid } from "@/pages/tina/items/components/key-value-grid";
import { PanelShell } from "@/pages/tina/items/components/panel-shell";
import { useRunsRepository } from "@/pages/tina/runs/hooks/use-runs-repository";
import type { PipelineItem } from "@/types/tina";

export function CancelledPanel({ item }: { item: PipelineItem }) {
  const repo = useRunsRepository();
  const { data, isLoading } = useQuery({
    queryKey: ["tina", "runs", item.run_id],
    queryFn: () => repo.get(item.run_id),
  });

  return (
    <PanelShell
      status="cancelled"
      subtitle="This item was cancelled because its parent run was cancelled."
    >
      <p className="text-sm leading-relaxed">
        Cancellation was issued at the run level. The item never reached a
        terminal data state — there is nothing downstream to inspect.
      </p>
      <KeyValueGrid
        rows={[
          {
            label: "Run",
            value: item.run_id.slice(0, 8),
            mono: true,
          },
          {
            label: "Run status",
            value: isLoading ? (
              <Skeleton className="h-4 w-24" />
            ) : (
              (data?.run.status ?? "—")
            ),
            mono: true,
          },
          {
            label: "Cancelled at",
            value: isLoading ? (
              <Skeleton className="h-4 w-40" />
            ) : data?.run.finished_at ? (
              dayjs(data.run.finished_at).format("DD/MM/YYYY HH:mm")
            ) : (
              "—"
            ),
          },
        ]}
      />
    </PanelShell>
  );
}
